import React from "react";

import styles from "./Hero.module.css";
import { getImageUrl } from "../../utils";
import Carousel from "react-bootstrap/Carousel";
import CoverPic from "../../assets/PackageImages/CoverPicFinal.jpg";
import Image1 from "../../assets/carouselImages/img8.jpg";
import Image2 from "../../assets/carouselImages/img3.jpg";
import Image3 from "../../assets/carouselImages/img5.jpg";
import Image4 from "../../assets/carouselImages/img7.jpg";
import { useMediaQuery, useTheme } from "@mui/material";

export const Hero = () => {
  const theme = useTheme();

  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <section className={styles.container}>
      {/* <Carousel>
        <Carousel.Item interval={2000}> */}
      <img
        style={{
          height: isMobile ? "12rem" : "30rem",
        }}
        class="d-block w-100"
        src={CoverPic}
      ></img>
      {/* </Carousel.Item> */}
      {/* <Carousel.Item interval={1000}>
          <img
            style={{
              height: "30rem",
            }}
            class="d-block w-100"
            src={CoverPic}
          ></img>
          <Carousel.Caption>
            <h3>Second slide label</h3>
            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
          </Carousel.Caption>
        </Carousel.Item> */}
      {/* <Carousel.Item>
          <img
            style={{
              height: "30rem",
            }}
            class="d-block w-100"
            src={Image3}
          ></img>
          <Carousel.Caption>
            <h3>Third slide label</h3>
            <p>
              Praesent commodo cursus magna, vel scelerisque nisl consectetur.
            </p>
          </Carousel.Caption>
        </Carousel.Item>
        <Carousel.Item>
          <img
            style={{
              height: "30rem",
            }}
            class="d-block w-100"
            src={Image4}
          ></img>
          <Carousel.Caption>
            <h3>Fourth slide label</h3>
            <p>
              Praesent commodo cursus magna, vel scelerisque nisl consectetur.
            </p>
          </Carousel.Caption>
        </Carousel.Item> */}
      {/* </Carousel> */}
    </section>
  );
};
